(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Agency-Section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // 图片切换（支持移动端滑动）
    const sectionEl = document.querySelector('.custom-image-product-card');
    if (sectionEl) {
      const thumbs = sectionEl.querySelectorAll('.thumb');
      const mains = Array.from(sectionEl.querySelectorAll('.main-img'));
      const sliderEl = sectionEl.querySelector('.main-img-slider');
      const dots = sectionEl.querySelectorAll('.main-img-dot');
      const prevBtn = sectionEl.querySelector('.main-img-prev');
      const nextBtn = sectionEl.querySelector('.main-img-next');
      let currentIdx = 0;

      const isMobile = () => window.innerWidth < 1024;

      function setActive(idx) {
        currentIdx = Math.max(0, Math.min(idx, mains.length - 1));
        if (isMobile()) {
          if (sliderEl) {
            sliderEl.scrollTo({ left: sliderEl.offsetWidth * currentIdx, behavior: 'smooth' });
          }
        } else {
          thumbs.forEach((t) => t.classList.remove('active'));
          mains.forEach((m) => m.classList.remove('active'));
          if (thumbs[currentIdx]) thumbs[currentIdx].classList.add('active');
          if (mains[currentIdx]) mains[currentIdx].classList.add('active');
        }
        dots.forEach((d, i) => d.classList.toggle('active', i === currentIdx));
        thumbs.forEach((t, i) => t.classList.toggle('active', i === currentIdx));
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => setActive(parseInt(thumb.dataset.index)));
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => setActive(parseInt(dot.dataset.index)));
      });

      if (prevBtn) prevBtn.addEventListener('click', () => setActive(currentIdx - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => setActive(currentIdx + 1));

      if (sliderEl) {
        sliderEl.addEventListener(
          'scroll',
          () => {
            const idx = Math.round(sliderEl.scrollLeft / (sliderEl.offsetWidth || 1));
            if (idx !== currentIdx) {
              currentIdx = idx;
              dots.forEach((d, i) => d.classList.toggle('active', i === idx));
              thumbs.forEach((t, i) => t.classList.toggle('active', i === idx));
            }
          },
          { passive: true }
        );
      }
    }

    // 弹窗按钮触发
    document.querySelectorAll('.btn-modal-trigger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const blockId = btn.dataset.blockId;
        document.getElementById('modal-' + blockId).style.display = 'flex';
      });
    });

    // 关闭弹窗
    document.querySelectorAll('.modal-close, .dealer-modal-overlay').forEach((el) => {
      el.addEventListener('click', (e) => {
        if (e.target === el || e.target.classList.contains('modal-close')) {
          el.closest('.dealer-modal-overlay').style.display = 'none';
        }
      });
    });

    // 表单提交
    document.querySelectorAll('[id^="dealer-form-"]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const btn = form.querySelector('button[type="submit"]');
        btn.disabled = true;
        btn.textContent = 'Submitting...';

        const data = {
          first_name: form.first_name.value.trim(),
          last_name: form.last_name.value.trim(),
          land: form.country.value,
          post_code: form.postcode.value.trim(),
          book_time: form.booktime.value.trim(),
          email_address: form.email.value.trim(),
          dealer_email: form.dealer_email.value,
        };

        try {
          const res = await fetch('https://accountapi.em-smart.com/appointment/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
          });

          if (res.ok) {
            alert('Thank you! Your inquiry has been sent successfully.');
            form.closest('.dealer-modal-overlay').style.display = 'none';
            form.reset();
          } else {
            throw new Error('Server error');
          }
        } catch (err) {
          alert('Submission failed, please try again later.');
          console.error(err);
        } finally {
          btn.disabled = false;
          btn.textContent = 'Submit';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["father-day-background"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-id="{{ section.id }}"]');
    if (!section) return;
    const canvas = section.querySelector('.father-day-canvas');
    const ctx = canvas.getContext('2d');

    let stars = [];

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    function initStars() {
      stars = [];
      const count = Math.floor((canvas.width * canvas.height) / 8000);
      for (let i = 0; i < count; i++) {
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: Math.random() * 1.5 + 0.3,
          alpha: Math.random() * 0.5 + 0.2,
          speed: Math.random() * 0.004 + 0.002,
          offset: Math.random() * Math.PI * 2
        });
      }
    }

    function draw(time) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      stars.forEach(function(s) {
        const alpha = s.alpha + Math.sin(time * s.speed + s.offset) * 0.15;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255, 255, 255, ' + alpha + ')';
        ctx.fill();
      });
      requestAnimationFrame(draw);
    }

    resize();
    initStars();
    requestAnimationFrame(draw);
    window.addEventListener('resize', function() {
      resize();
      initStars();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-tab-with-slider"] && !Shopify.designMode) return;
  try {
    
  var scrollPosition = 0;
  var HomeTabWithSlider = class extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('.htws-tabs');
      this.swiper = null;
      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
    }
    init() {
      this.items.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.setIndex(i);
          this.swiper.slideToLoop(i);
        });
      });
      let id = this.getAttribute('sid');
      let className = '.swiper-' + id;
      this.swiper = new Swiper(className, {
        loop: true,
        navigation: {
          nextEl: '.htws-next',
          prevEl: '.htws-prev',
        },
        on: {
          activeIndexChange: (e) => {
            this.setIndex(e.realIndex);
          },
          slideChangeTransitionEnd: function () {
            setTimeout(() => {
              // 获取当前激活的标签页
              var $tab = $('.htws-tabs[show="1"]');
              if (!$tab.length) return;

              // 获取父容器和第一个子标题元素
              var $parent = $tab.parent();
              var $firstSubtitle = $parent.find('.htws-tab-subtitle').first();

              var isDesktop = $(window).width() > 750;

              // 计算目标位置（标签页位置 - 子标题位置）
              if (isDesktop) {
                var $firstSubtitle = $parent.find('.htws-tab-subtitle').first();
              } else {
                var $firstSubtitle = $parent.find('.htws-tabs').first();
              }
              var tabPosition = $tab.position()[isDesktop ? 'top' : 'left'];
              var subtitlePosition = $firstSubtitle.position()[isDesktop ? 'top' : 'left'];
              var scrollPosition = tabPosition - subtitlePosition;

              // 执行滚动（带防抖和动画停止）
              $parent
                .stop(true)
                .animate(isDesktop ? { scrollTop: scrollPosition - 100 } : { scrollLeft: scrollPosition }, 500);
            }, 50); // 延迟确保DOM更新
          },
        },
      });
    }
    setIndex(i) {
      this.items.forEach((ite) => {
        ite.setAttribute('show', '');
      });

      this.items[i].setAttribute('show', '1');
    }
  };
  if (!window.customElements.get('home-tab-with-slider')) {
    window.customElements.define('home-tab-with-slider', HomeTabWithSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-sunshine-background"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const springSections = document.querySelectorAll('.section__spring-sunshine');
    springSections.forEach(function (section) {
      const canvas = section.querySelector('.spring-canvas');
      if (!canvas) return;

      const ctx = canvas.getContext('2d');

      let petals = [];
      let pollen = [];
      let leaves = [];
      let butterflies = [];

      // Spring color palette
      const petalColors = [
        '#FFB7C5', // Cherry blossom pink
        '#FF85A1', // Deep pink
        '#FFC0CB', // Light pink
        '#FFD1DC', // Blush
        '#FFDDE1', // Very light pink
        '#FFF0F5', // Lavender blush
        '#FFFACD', // Lemon chiffon (white blossom)
        '#F8E1F4', // Thistle
      ];

      const leafColors = [
        '#7EC850', // Fresh green
        '#A8D770', // Light green
        '#5BAD3A', // Medium green
        '#C5E89A', // Pale green
        '#90C83C', // Yellow-green
      ];

      const pollenColor = 'rgba(255, 235, 59, 0.75)';

      // ─── Resize ───────────────────────────────────────────
      function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        init();
      }

      // ─── Init all elements ────────────────────────────────
      function init() {
        petals = [];
        pollen = [];
        leaves = [];
        butterflies = [];

        const petalCount = Math.max(18, Math.floor(canvas.width / 55));
        for (let i = 0; i < petalCount; i++) {
          petals.push(createPetal(true));
        }

        const pollenCount = 60;
        for (let i = 0; i < pollenCount; i++) {
          pollen.push(createPollen(true));
        }

        const leafCount = Math.max(6, Math.floor(canvas.width / 220));
        for (let i = 0; i < leafCount; i++) {
          leaves.push(createLeaf(true));
        }

        const butterflyCount = Math.max(2, Math.floor(canvas.width / 500));
        for (let i = 0; i < butterflyCount; i++) {
          butterflies.push(createButterfly(true));
        }
      }

      // ─── Factories ────────────────────────────────────────
      function createPetal(scatter) {
        return {
          x: scatter ? Math.random() * canvas.width : canvas.width + 40,
          y: scatter ? Math.random() * canvas.height : Math.random() * canvas.height * 0.6,
          size: Math.random() * 14 + 7,
          color: petalColors[Math.floor(Math.random() * petalColors.length)],
          speedX: -(Math.random() * 1.5 + 0.4),
          speedY: Math.random() * 0.8 + 0.3,
          wobble: Math.random() * Math.PI * 2,
          wobbleSpeed: Math.random() * 0.03 + 0.01,
          wobbleAmp: Math.random() * 30 + 10,
          rotation: Math.random() * Math.PI * 2,
          rotSpeed: (Math.random() - 0.5) * 0.04,
          opacity: Math.random() * 0.55 + 0.35,
        };
      }

      function createPollen(scatter) {
        return {
          x: scatter ? Math.random() * canvas.width : canvas.width + 5,
          y: scatter ? Math.random() * canvas.height : Math.random() * canvas.height,
          size: Math.random() * 2.5 + 1,
          speedX: -(Math.random() * 0.8 + 0.2),
          speedY: (Math.random() - 0.4) * 0.5,
          opacity: Math.random() * 0.5 + 0.2,
          pulse: Math.random() * 0.04 + 0.01,
          t: Math.random() * Math.PI * 2,
        };
      }

      function createLeaf(scatter) {
        return {
          x: scatter ? Math.random() * canvas.width : canvas.width + 30,
          y: scatter ? Math.random() * canvas.height * 0.7 : Math.random() * canvas.height * 0.5,
          width: Math.random() * 28 + 16,
          height: Math.random() * 14 + 8,
          color: leafColors[Math.floor(Math.random() * leafColors.length)],
          speedX: -(Math.random() * 1.2 + 0.3),
          speedY: Math.random() * 0.6 + 0.2,
          wobble: Math.random() * Math.PI * 2,
          wobbleSpeed: Math.random() * 0.025 + 0.008,
          wobbleAmp: Math.random() * 25 + 10,
          rotation: Math.random() * Math.PI,
          rotSpeed: (Math.random() - 0.5) * 0.025,
          opacity: Math.random() * 0.4 + 0.25,
        };
      }

      function createButterfly(scatter) {
        return {
          x: scatter ? Math.random() * canvas.width : canvas.width + 40,
          y: scatter ? Math.random() * canvas.height * 0.7 : Math.random() * canvas.height * 0.6,
          size: Math.random() * 14 + 10,
          speedX: -(Math.random() * 1.0 + 0.3),
          speedY: 0,
          t: Math.random() * Math.PI * 2,
          flapSpeed: Math.random() * 0.1 + 0.06,
          color1: petalColors[Math.floor(Math.random() * petalColors.length)],
          color2: '#FFD700',
          opacity: Math.random() * 0.4 + 0.4,
          driftAmp: Math.random() * 40 + 20,
          driftFreq: Math.random() * 0.015 + 0.005,
          baseY: 0,
        };
      }

      // ─── Draw functions ───────────────────────────────────

      function drawPetal(p) {
        p.wobble += p.wobbleSpeed;
        p.rotation += p.rotSpeed;
        p.x += p.speedX + Math.sin(p.wobble) * 0.5;
        p.y += p.speedY;

        if (p.x < -30 || p.y > canvas.height + 30) {
          Object.assign(p, createPetal(false));
          return;
        }

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.globalAlpha = p.opacity;

        // Petal shape: two ellipses meeting at a point
        ctx.beginPath();
        ctx.ellipse(0, -p.size * 0.4, p.size * 0.45, p.size * 0.9, 0, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.shadowColor = p.color;
        ctx.shadowBlur = 6;
        ctx.fill();

        // Subtle center line
        ctx.beginPath();
        ctx.moveTo(0, -p.size * 0.9);
        ctx.lineTo(0, p.size * 0.5);
        ctx.strokeStyle = 'rgba(255,150,160,0.3)';
        ctx.lineWidth = 0.8;
        ctx.stroke();

        ctx.restore();
      }

      function drawPollen(p) {
        p.t += p.pulse;
        p.x += p.speedX;
        p.y += p.speedY + Math.sin(p.t) * 0.3;
        p.opacity = Math.abs(Math.sin(p.t * 0.8)) * 0.45 + 0.15;

        if (p.x < -5) {
          Object.assign(p, createPollen(false));
          return;
        }

        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fillStyle = pollenColor;
        ctx.shadowColor = '#FFE066';
        ctx.shadowBlur = 5;
        ctx.fill();
        ctx.restore();
      }

      function drawLeaf(l) {
        l.wobble += l.wobbleSpeed;
        l.rotation += l.rotSpeed;
        l.x += l.speedX + Math.sin(l.wobble * 0.7) * 0.4;
        l.y += l.speedY;

        if (l.x < -40 || l.y > canvas.height + 30) {
          Object.assign(l, createLeaf(false));
          return;
        }

        ctx.save();
        ctx.translate(l.x, l.y);
        ctx.rotate(l.rotation + Math.sin(l.wobble) * 0.2);
        ctx.globalAlpha = l.opacity;

        // Leaf shape
        ctx.beginPath();
        ctx.save();
        ctx.scale(1, l.height / l.width);
        ctx.arc(0, 0, l.width / 2, 0, Math.PI * 2);
        ctx.restore();
        ctx.fillStyle = l.color;
        ctx.shadowColor = l.color;
        ctx.shadowBlur = 4;
        ctx.fill();

        // Mid vein
        ctx.beginPath();
        ctx.moveTo(-l.width * 0.45, 0);
        ctx.lineTo(l.width * 0.45, 0);
        ctx.strokeStyle = 'rgba(255,255,255,0.35)';
        ctx.lineWidth = 0.8;
        ctx.stroke();

        ctx.restore();
      }

      function drawButterfly(b) {
        b.t += b.flapSpeed;
        b.x += b.speedX;
        b.y = b.baseY + Math.sin(b.t * b.driftFreq * 80) * b.driftAmp;

        if (b.x < -50) {
          Object.assign(b, createButterfly(false));
          b.baseY = b.y;
          return;
        }
        if (b.baseY === 0) b.baseY = b.y;

        const flapAngle = Math.abs(Math.sin(b.t)) * 0.8; // 0 = open, 0.8 = closed

        ctx.save();
        ctx.translate(b.x, b.y);
        ctx.globalAlpha = b.opacity;

        // Left wings
        ctx.save();
        ctx.scale(-1 + flapAngle, 1);
        // Upper wing
        ctx.beginPath();
        ctx.ellipse(-b.size * 0.5, -b.size * 0.3, b.size * 0.7, b.size * 0.5, -0.3, 0, Math.PI * 2);
        ctx.fillStyle = b.color1;
        ctx.shadowColor = b.color1;
        ctx.shadowBlur = 5;
        ctx.fill();
        // Lower wing
        ctx.beginPath();
        ctx.ellipse(-b.size * 0.4, b.size * 0.25, b.size * 0.5, b.size * 0.35, 0.3, 0, Math.PI * 2);
        ctx.fillStyle = b.color2;
        ctx.fill();
        ctx.restore();

        // Right wings
        ctx.save();
        ctx.scale(1 - flapAngle, 1);
        ctx.beginPath();
        ctx.ellipse(b.size * 0.5, -b.size * 0.3, b.size * 0.7, b.size * 0.5, 0.3, 0, Math.PI * 2);
        ctx.fillStyle = b.color1;
        ctx.shadowColor = b.color1;
        ctx.shadowBlur = 5;
        ctx.fill();
        ctx.beginPath();
        ctx.ellipse(b.size * 0.4, b.size * 0.25, b.size * 0.5, b.size * 0.35, -0.3, 0, Math.PI * 2);
        ctx.fillStyle = b.color2;
        ctx.fill();
        ctx.restore();

        // Body
        ctx.beginPath();
        ctx.ellipse(0, 0, 1.5, b.size * 0.4, 0, 0, Math.PI * 2);
        ctx.fillStyle = '#5D3A1A';
        ctx.globalAlpha = b.opacity * 0.7;
        ctx.fill();

        ctx.restore();
      }

      // ─── Animation loop ───────────────────────────────────
      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        pollen.forEach(drawPollen);
        leaves.forEach(drawLeaf);
        petals.forEach(drawPetal);
        butterflies.forEach(drawButterfly);

        requestAnimationFrame(animate);
      }

      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
      animate();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starry-sky"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const starrySections = document.querySelectorAll('.section__starry-sky');
    starrySections.forEach(function (section) {
      const canvas = section.querySelector('.starry-sky-canvas');
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      let stars = [];
      let shootingStars = [];

      function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        initStars();
      }

      function initStars() {
        stars = [];
        const starCount = Math.floor((canvas.width * canvas.height) / 3000);

        for (let i = 0; i < starCount; i++) {
          stars.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            size: Math.random() * 2,
            brightness: Math.random(),
            twinkleSpeed: Math.random() * 0.05 + 0.01,
          });
        }
      }

      function createShootingStar() {
        if (Math.random() < 0.01 && shootingStars.length < 3) {
          shootingStars.push({
            x: Math.random() * canvas.width,
            y: 0,
            length: Math.random() * 80 + 20,
            speed: Math.random() * 10 + 5,
            opacity: 1,
            angle: Math.random() * 60 + 30,
          });
        }
      }

      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw stars
        stars.forEach((star) => {
          star.brightness += star.twinkleSpeed;
          if (star.brightness > 1 || star.brightness < 0) {
            star.twinkleSpeed = -star.twinkleSpeed;
          }

          ctx.beginPath();
          ctx.arc(star.x, star.y, star.size, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255, 255, 255, ${star.brightness * 0.8})`;
          ctx.fill();

          // Add glow effect for larger stars
          if (star.size > 1) {
            ctx.beginPath();
            ctx.arc(star.x, star.y, star.size * 2, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(255, 255, 255, ${star.brightness * 0.2})`;
            ctx.fill();
          }
        });

        // Draw and update shooting stars
        shootingStars = shootingStars.filter((star) => {
          const radians = (star.angle * Math.PI) / 180;
          star.x += Math.cos(radians) * star.speed;
          star.y += Math.sin(radians) * star.speed;
          star.opacity -= 0.02;

          if (star.opacity > 0 && star.y < canvas.height) {
            const gradient = ctx.createLinearGradient(
              star.x,
              star.y,
              star.x - Math.cos(radians) * star.length,
              star.y - Math.sin(radians) * star.length
            );
            gradient.addColorStop(0, `rgba(255, 255, 255, ${star.opacity})`);
            gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

            ctx.strokeStyle = gradient;
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(star.x, star.y);
            ctx.lineTo(star.x - Math.cos(radians) * star.length, star.y - Math.sin(radians) * star.length);
            ctx.stroke();

            return true;
          }
          return false;
        });

        createShootingStar();
        requestAnimationFrame(animate);
      }

      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
      animate();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-bowl-ribbons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const ribbonSections = document.querySelectorAll('.section__super-bowl-ribbons');
    ribbonSections.forEach(function (section) {
      const canvas = section.querySelector('.ribbons-canvas');
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      let ribbons = [];
      let particles = [];

      // Super Bowl color palette
      const colors = [
        '#FFD700', // Gold
        '#FFFFFF', // White
        '#FF6B35', // Orange
        '#4A90E2', // Blue accent
        'rgba(255, 215, 0, 0.8)', // Transparent gold
        'rgba(255, 255, 255, 0.6)', // Transparent white
      ];

      function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        initRibbons();
      }

      function initRibbons() {
        ribbons = [];
        particles = [];
        const ribbonCount = Math.floor(canvas.width / 200);

        for (let i = 0; i < ribbonCount; i++) {
          ribbons.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            width: Math.random() * 60 + 20,
            height: Math.random() * 150 + 100,
            color: colors[Math.floor(Math.random() * colors.length)],
            speed: Math.random() * 2 + 0.5,
            amplitude: Math.random() * 50 + 20,
            frequency: Math.random() * 0.02 + 0.01,
            phase: Math.random() * Math.PI * 2,
            opacity: Math.random() * 0.3 + 0.1,
            rotation: Math.random() * Math.PI * 2,
            rotationSpeed: (Math.random() - 0.5) * 0.02,
          });
        }

        // Add floating particles
        for (let i = 0; i < 50; i++) {
          particles.push({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            size: Math.random() * 3 + 1,
            color: colors[Math.floor(Math.random() * colors.length)],
            speed: Math.random() * 1 + 0.2,
            opacity: Math.random() * 0.5 + 0.2,
            pulse: Math.random() * 0.02 + 0.01,
          });
        }
      }

      function drawRibbon(ribbon) {
        ctx.save();

        // Update position
        ribbon.x -= ribbon.speed;
        ribbon.y += Math.sin(ribbon.x * ribbon.frequency + ribbon.phase) * ribbon.amplitude * 0.1;
        ribbon.rotation += ribbon.rotationSpeed;

        // Reset position if off screen
        if (ribbon.x + ribbon.width < 0) {
          ribbon.x = canvas.width + ribbon.width;
          ribbon.y = Math.random() * canvas.height;
        }

        // Apply rotation
        ctx.translate(ribbon.x, ribbon.y);
        ctx.rotate(ribbon.rotation);

        // Create gradient for ribbon
        const gradient = ctx.createLinearGradient(0, -ribbon.height / 2, 0, ribbon.height / 2);
        gradient.addColorStop(0, ribbon.color);
        gradient.addColorStop(0.5, ribbon.color.replace('0.8', '0.4').replace('0.6', '0.3'));
        gradient.addColorStop(1, ribbon.color);

        // Draw ribbon with curves
        ctx.beginPath();
        ctx.moveTo(-ribbon.width / 2, -ribbon.height / 2);

        // Create wavy ribbon effect
        const segments = 8;
        for (let i = 0; i <= segments; i++) {
          const t = i / segments;
          const y = -ribbon.height / 2 + ribbon.height * t;
          const waveX = Math.sin(t * Math.PI * 2 + ribbon.phase) * ribbon.amplitude * 0.3;
          const width = ribbon.width * (1 - Math.abs(t - 0.5) * 0.3);

          if (i === 0) {
            ctx.moveTo(-width / 2 + waveX, y);
          } else {
            ctx.lineTo(-width / 2 + waveX, y);
          }
        }

        for (let i = segments; i >= 0; i--) {
          const t = i / segments;
          const y = -ribbon.height / 2 + ribbon.height * t;
          const waveX = Math.sin(t * Math.PI * 2 + ribbon.phase) * ribbon.amplitude * 0.3;
          const width = ribbon.width * (1 - Math.abs(t - 0.5) * 0.3);
          ctx.lineTo(width / 2 + waveX, y);
        }

        ctx.closePath();

        // Apply styles
        ctx.fillStyle = gradient;
        ctx.globalAlpha = ribbon.opacity;
        ctx.fill();

        // Add glow effect
        ctx.shadowColor = ribbon.color;
        ctx.shadowBlur = 10;
        ctx.globalAlpha = ribbon.opacity * 0.5;
        ctx.fill();

        ctx.restore();
      }

      function drawParticle(particle) {
        particle.x -= particle.speed;
        particle.y += Math.sin(particle.x * 0.01) * 0.5;
        particle.opacity = Math.abs(Math.sin(Date.now() * particle.pulse)) * 0.5 + 0.2;

        if (particle.x < -10) {
          particle.x = canvas.width + 10;
          particle.y = Math.random() * canvas.height;
        }

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fillStyle = particle.color;
        ctx.globalAlpha = particle.opacity;
        ctx.fill();

        // Add glow
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size * 2, 0, Math.PI * 2);
        ctx.fillStyle = particle.color;
        ctx.globalAlpha = particle.opacity * 0.2;
        ctx.fill();
      }

      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Draw particles first (background)
        particles.forEach(drawParticle);

        // Draw ribbons
        ribbons.forEach(drawRibbon);

        requestAnimationFrame(animate);
      }

      resizeCanvas();
      window.addEventListener('resize', resizeCanvas);
      animate();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
